import React from 'react';
import Header from '../../hoc/Layout/Header';
import FulcrumOrbLogo from '../../assets/fulcrum-orb-logo.svg';
import styles from './LandingPage.module.scss';

const LandingPage = () => {
  return (
    <div className={styles.page}>
      <Header />
      <main className={styles.hero}>
        <img className={styles.orbLogo} src={FulcrumOrbLogo} alt="Fulcrum" />
      </main>
    </div>
  );
};

export default LandingPage;
